var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selects"},[_c('div',{class:this.agreeStatus === 'AGREE'
                ? ['user-like', 'thumb']
                : ['init-like', 'thumb'],on:{"click":function($event){return _vm.handleThumbClick('like', _vm.item)}}}),_vm._v(" "),_c('span',{staticClass:"vertical"},[_vm._v("|")]),_vm._v(" "),_c('div',{class:this.agreeStatus === 'TREAD'
                ? ['user-dislike', 'thumb']
                : ['init-dislike', 'thumb'],on:{"click":function($event){return _vm.handleThumbClick('dislike', _vm.item)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }